import { TransferAppEndAction } from "../actions";
import { AdminState } from "../state";

import { updateAppInState } from "./Common";

export function transferApp(state: AdminState, action: TransferAppEndAction): AdminState {
    return updateAppInState(state, action);
}
